(function ($) {
    "use strict";

    return;
    // Código abaixo ocultado para evitar duplicidade de disparo de eventos para o datalayer.
    // Caso não gere impactos negativos, iremos remover esse arquivo futuramente.

    // var _dataLayerFiltered = dataLayer.filter(function (e) {
    //     return e.ET;
    // })[0];

    // if (_dataLayerFiltered !== undefined) {
    //     if (
    //         _dataLayerFiltered.ET === "catalogpage" ||
    //         _dataLayerFiltered.ET === "landingpage" ||
    //         _dataLayerFiltered.ET === "productpage"
    //     ) {
    //         var obj1 = {
    //             event: "store_country",
    //             store_country: "br",
    //         };
    //         dataLayer.push(obj1);
    //         if (window.DD_RUM && window.DD_RUM.addAction) {
    //             window.DD_RUM.addAction(obj1.event, obj1);
    //         }

    //         if ($.cookie("feature_flag_uuid")) {
    //             var deviceData = {
    //                 event: "device_uuid",
    //                 device_uuid: $.cookie("feature_flag_uuid"),
    //             };
    //             dataLayer.push(deviceData);
    //         }

    //         if ($.cookie("customer")) {
    //             var obj2 = {
    //                 event: "user_id",
    //                 user_id: $.cookie("customer"),
    //             };
    //             dataLayer.push(obj2);
    //             if (window.DD_RUM && window.DD_RUM.addAction) {
    //                 window.DD_RUM.addAction(obj2.event, obj2);
    //             }
    //         }
    //     }
    // }
})(jQuery);
